import React, { PureComponent } from 'react'
import styles from './styles'
import logoImg from 'app/Components/Logo/logo.png'

export default class LogoSmall extends PureComponent {
  render() {
    return (
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <div>
            <img src={logoImg} alt='' className={styles.logo} />
            <div className={styles.logoTitle}>
              <div className={styles.logoInitials}>GHNI</div>
              <div className={styles.logoName}>Greater Houston</div>
              <div className={styles.logoSubname}>Neurological Institute</div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ../app/Components/LogoSmall/LogoSmall.js
 **/